const AddJob = () => {
  return (
    <img
      width="20"
      height="20"
      src="https://img.icons8.com/ios/100/add-property.png"
      alt="add-property"
      color="#0f1560"
    />
  );
};

export default AddJob;
